// extracted by mini-css-extract-plugin
export default {"exchange_d":"Exchange_exchange_d__FA0K8","exchange_l":"Exchange_exchange_l__0Q91m","exchange_grids":"Exchange_exchange_grids__P+Xu4"};